var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCancelledStatus(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12C0 5.37258 5.37258 0 12 0ZM12 2C6.47715 2 2 6.47715 2 12C2 17.5228 6.47715 22 12 22C17.5228 22 22 17.5228 22 12C22 6.47715 17.5228 2 12 2ZM12 15.7891C12.6904 15.7891 13.25 16.3488 13.25 17.0391C13.25 17.7295 12.6904 18.2891 12 18.2891C11.3096 18.2891 10.75 17.7295 10.75 17.0391C10.75 16.3488 11.3096 15.7891 12 15.7891ZM12 5.91758C12.5523 5.91758 13 6.3653 13 6.91758V13.438C13 13.9903 12.5523 14.438 12 14.438C11.4477 14.438 11 13.9903 11 13.438V6.91758C11 6.3653 11.4477 5.91758 12 5.91758Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCancelledStatus);
export default __webpack_public_path__ + "static/media/cancelled_status.26fde2a4cccdff810309808a0691fe45.svg";
export { ForwardRef as ReactComponent };